module.exports = __webpack_public_path__ + "img/HY1701-173.05af0105.jpg";